import { API_BASE_URL } from "./config";
import { authHeadersForGet, authHeadersJson } from "./http";
import { Address, CreateAddressDto } from "../types/address";

function extractMessage(data: unknown): string | null {
  if (typeof data === "object" && data !== null && "message" in data) {
    const m = (data as { message: unknown }).message;
    if (typeof m === "string") {
      return m;
    }
    if (Array.isArray(m)) {
      return m.map(String).join(", ");
    }
  }
  return null;
}

function mapAddressFromApi(json: unknown): Address {
  if (typeof json !== "object" || json === null) {
    throw new Error("Respuesta inválida del servidor");
  }
  const o = json as Record<string, unknown>;
  const refDesc = o.referenceDescription ?? o.reference_note;
  const base = json as Address;
  return {
    ...base,
    reference_note:
      typeof refDesc === "string" && refDesc.length > 0 ? refDesc : base.reference_note,
  };
}

export const addressesApi = {
  getByClientReference: async (clientReference: string): Promise<Address[]> => {
    const response = await fetch(
      `${API_BASE_URL}/addresses/client/${clientReference}`,
      { headers: authHeadersForGet() }
    );
    const data: unknown = await response.json();
    if (!response.ok) {
      return [];
    }
    if (!Array.isArray(data)) {
      return [];
    }
    return data.map((item) => mapAddressFromApi(item));
  },

  create: async (
    clientReference: string,
    address: CreateAddressDto
  ): Promise<Address> => {
    const response = await fetch(
      `${API_BASE_URL}/addresses/client/${clientReference}`,
      {
        method: "POST",
        headers: authHeadersJson(),
        body: JSON.stringify(address),
      }
    );
    const data: unknown = await response.json();
    if (!response.ok) {
      throw new Error(extractMessage(data) ?? `Error ${response.status}`);
    }
    return mapAddressFromApi(data);
  },

  update: async (
    reference: string,
    address: Partial<CreateAddressDto>
  ): Promise<Address> => {
    const response = await fetch(`${API_BASE_URL}/addresses/${reference}`, {
      method: "PUT",
      headers: authHeadersJson(),
      body: JSON.stringify(address),
    });
    const data: unknown = await response.json();
    if (!response.ok) {
      throw new Error(extractMessage(data) ?? `Error ${response.status}`);
    }
    return mapAddressFromApi(data);
  },

  delete: async (reference: string): Promise<boolean> => {
    const response = await fetch(`${API_BASE_URL}/addresses/${reference}`, {
      method: "DELETE",
      headers: authHeadersForGet(),
    });
    return response.ok;
  },
};

export type AddressesApi = typeof addressesApi;
